module.exports = __webpack_public_path__ + "img/1. COGS TCA, TCE, TCW_1_edit.cab3eff7.jpg";